/*
 * dän v3.9 Bulk orders: dozens per line, pickup store and day, add everything to the bag at once.
 * Catering lead times (assets/dan-cart.js firstDay, BakeOps rules.ts): never same-day; the first day is tomorrow
 * when ordered before pickupCutoff, otherwise the day after; one day more if a chosen line is lead-48h.
 * Hand-off to the bag: localStorage danStore (via danSetStore) and danPickupDay, as on the cake page.
 */
(function () {
  var root = document.querySelector('[data-d9-bulk]');
  var dataEl = document.querySelector('[data-d9-bulk-data]');
  if (!root || !dataEl) return;
  var D = JSON.parse(dataEl.textContent), LINES = D.lines, LEAD48 = D.lead48 || [];
  var R = window.DAN_ORDERING || {};
  var qty = {}, chosenDay = null, chosen = false;

  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return [].slice.call(root.querySelectorAll(s)); };
  var daysEl = $('[data-d9-days]'), msg = $('[data-d9-msg]'), go = $('[data-d9-go]'), MSG0 = msg.textContent;

  function hOf(x, d) { var p = String(x || d).split(':'); return +p[0] + (+p[1] || 0) / 60; }
  function clock(h) { var H = Math.floor(h + 1e-9), m = Math.round((h - H) * 60); return (H % 12 || 12) + (m ? ':' + (m < 10 ? '0' : '') + m : '') + ' ' + (H >= 12 ? 'PM' : 'AM'); }
  function money(c) { var v = c / 100; return '$' + (v % 1 ? v.toFixed(2) : v.toFixed(0)); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
  function track(o) { try { (window.dataLayer = window.dataLayer || []).push(o); } catch (e) {} }
  function nowNY() {
    var p = {};
    new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: false })
      .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return { y: +p.year, m: +p.month, d: +p.day, h: (+p.hour % 24) + (+p.minute) / 60 };
  }
  function day(k) {
    var n = nowNY(), dt = new Date(Date.UTC(n.y, n.m - 1, n.d + k));
    return { k: k, iso: dt.toISOString().slice(0, 10), dow: dt.getUTCDay(), top: k === 1 ? 'Tomorrow' : dt.toLocaleDateString('en-US', { weekday: 'short', timeZone: 'UTC' }), sub: dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' }) };
  }
  function store() { try { var k = localStorage.getItem('danStore'); return window.DAN_STORES && window.DAN_STORES[k] ? k : null; } catch (e) { return null; } }
  function open(k, d) { var s = window.DAN_STORES && window.DAN_STORES[k]; if (!s || !s.hours) return true; return !!s.hours[d.dow] && (s.closedDates || []).indexOf(d.iso) < 0; }
  var CUT = hOf(R.pickupCutoff || D.pickupCutoff, '18:00');
  function lead() { return Object.keys(qty).some(function (id) { return LEAD48.indexOf(+id) > -1; }) ? 2 : 1; }
  function days(k) {
    var out = [];
    for (var i = lead() + (nowNY().h >= CUT ? 1 : 0); i < 21 && out.length < 6; i++) { var d = day(i); if (!k || open(k, d)) out.push(d); }
    return out;
  }

  function render() {
    var k = store(), ids = Object.keys(qty), total = 0, count = 0;
    $$('input[name="store"]').forEach(function (r) { r.checked = r.value === k; });
    var list = days(k);
    if (!chosen || !list.some(function (d) { return d.iso === chosenDay; })) chosenDay = list[0] ? list[0].iso : null;
    daysEl.innerHTML = list.map(function (d) { return '<label class="d9-day"><input type="radio" name="day" value="' + d.iso + '"' + (d.iso === chosenDay ? ' checked' : '') + '><span><b>' + d.top + '</b><small>' + d.sub + '</small></span></label>'; }).join('');
    $('[data-d9-picked]').innerHTML = ids.map(function (id) {
      var l = LINES[id], q = qty[id]; total += l.price * q; count += q;
      return '<li><span>' + q + ' × ' + esc(l.name) + ' · ' + esc(l.size) + '</span><span class="d9-num">' + money(l.price * q) + '</span></li>';
    }).join('');
    $('[data-d9-empty]').hidden = count > 0;
    $('[data-d9-total]').textContent = money(total);
    $$('[data-d9-n]').forEach(function (o) { var id = o.getAttribute('data-d9-n'), q = qty[id] || 0; o.textContent = q; o.closest('.d9-bulk__line').classList.toggle('is-on', q > 0); });
    $$('[data-d9-dec]').forEach(function (b) { b.disabled = !qty[b.getAttribute('data-d9-dec')]; });
    var rule = $('[data-d9-bulk-rule]'); if (rule) rule.textContent = 'Pick up at any dän. Order by ' + clock(CUT) + (lead() > 1 ? ', two days ahead.' : ' the day before.');
    go.disabled = !count;
    go.textContent = count ? 'Add to bag · ' + money(total) : 'Add to bag';
    var bar = $('[data-d9-bar]'); bar.classList.toggle('is-on', count > 0); bar.setAttribute('aria-hidden', count ? 'false' : 'true'); bar.querySelector('a').tabIndex = count ? 0 : -1;
    $('[data-d9-bar-t]').textContent = count + (count === 1 ? ' box · ' : ' boxes · ') + money(total);
  }
  function say(t, err) { msg.textContent = t; msg.classList.toggle('is-err', !!err); }

  root.addEventListener('click', function (e) {
    var inc = e.target.closest('[data-d9-inc]'), dec = e.target.closest('[data-d9-dec]');
    if (inc) { var a = inc.getAttribute('data-d9-inc'); qty[a] = (qty[a] || 0) + 1; say(MSG0); render(); }
    if (dec) { var b = dec.getAttribute('data-d9-dec'); qty[b] = (qty[b] || 0) - 1; if (qty[b] <= 0) delete qty[b]; render(); }
  });
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.name === 'store') { if (window.danSetStore) window.danSetStore(t.value); else { try { localStorage.setItem('danStore', t.value); } catch (x) {} } track({ event: 'fulfillment_selection', dan_store: t.value, dan_source: 'bulk' }); say(MSG0); }
    if (t.name === 'day') { chosenDay = t.value; chosen = true; }
    render();
  });
  window.addEventListener('dan:store', render);

  go.addEventListener('click', function () {
    var k = store(), ids = Object.keys(qty);
    if (!ids.length) return;
    if (!k) { say('Choose the dän you’ll pick up from.', true); var f = root.querySelector('input[name="store"]'); f && f.focus(); return; }
    if (!chosenDay) { say('Choose a pickup day.', true); return; }
    if (!window.danCart) { say('Something went wrong. Please refresh the page and try again.', true); return; }
    try { localStorage.setItem('danPickupDay', chosenDay); } catch (x) {}
    go.disabled = true; go.setAttribute('aria-busy', 'true'); say('Adding to your bag…');
    var items = ids.map(function (id) { return { id: +id, quantity: qty[id] }; });
    window.danCart.add(items, { open: true, name: 'Your dozens' }).then(function () {
      var value = ids.reduce(function (s, id) { return s + LINES[id].price * qty[id]; }, 0);
      track({ event: 'dan_add_to_bag', dan_source: 'bulk', dan_store: k, dan_day: chosenDay, ecommerce: { currency: 'USD', value: value / 100, items: ids.map(function (id) { return { item_id: LINES[id].sku, item_name: LINES[id].name + ' · ' + LINES[id].size, price: LINES[id].price / 100, quantity: qty[id] }; }) } });
      qty = {}; say('Added. Choose your pickup time in the bag, then check out.');
    }).catch(function (err) { say((err && err.message) || 'Could not add to your bag. Please try again.', true); })
      .then(function () { go.removeAttribute('aria-busy'); render(); });
  });

  render();
  setInterval(render, 60000);
})();
